define('shared/initializer/form/newHouseAdapters/util/createAfterSubmitLifeCycle',['Promise'], function(Promise){
    return function createBeforeRedirectDelegate(callbackName, context) {
        function BeforeRedirectDelegate() {

        }

        BeforeRedirectDelegate.prototype.doAfterSubmit = function(data){
            return new Promise(function(resolve, reject){
                if ( typeof context[callbackName] === 'function' ) {
                    context[callbackName](data)
                        .then(function () {
                            resolve(data);
                        }, reject);
                }
                else {
                    resolve(data);
                }
            });
        };

        return BeforeRedirectDelegate;
    };
});
